import {
  ButtonStyled,
} from '@nike/nike-design-system-components';
import { AlertCircle, CheckCircle } from '@nike/nike-design-system-icons';
import PropTypes from 'prop-types';
import React from 'react';
import { CSVLink } from 'react-csv';
import { connect } from 'react-redux';

import { dateFormatterTable } from '../../utils/formatting';
import { locales } from '../../utils/locales';
import ButtonBlack from '../reusable/ButtonBlack';
import PopupConfirm from '../reusable/PopupConfirm';

class ExportSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenExportConfirm: false,
      isOpenExportSuccess: false,
    };
  }

  closeModal = (modelName) => {
    this.setState({
      [modelName === 'exportConfirm'
        ? 'isOpenExportConfirm'
        : 'isOpenExportSuccess']: false,
    });
  };

  getCsvData = (data) => {
    const { storeTimezone, storeLocale } = this.props.storeInfo;

    const csvHeaders = [
      'Transaction Start Date',
      'Transaction Number',
      'Device Number',
      'Operator Number',
      'Transaction Amount',
    ];

    const csvRows = data.map(
      ({
        transactionStartDate,
        transactionNumber,
        deviceNumber,
        operatorNumber,
        transactionAmount,
      }) => [
        dateFormatterTable(
          transactionStartDate,
          storeTimezone,
          locales(storeLocale)?.momentFormat || 'MM/DD/YYYY'
        ),
        transactionNumber,
        deviceNumber,
        operatorNumber,
        transactionAmount,
      ]
    );
    return [csvHeaders, ...csvRows];
  };

  handleExportClick = () => {
    this.openModal('exportConfirm');
  };

  openModal = (modelName) => {
    this.setState({
      [modelName === 'exportConfirm'
        ? 'isOpenExportConfirm'
        : 'isOpenExportSuccess']: true,
    });
  };

  submitExportWarning = () => {
    this.setState({ isOpenExportConfirm: false, isOpenExportSuccess: true });
  };

  render = () => (
    <>
      <header
        className="ncss-row"
        style={{
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'space-between',
          position: 'relative',
        }}
      >
        <p
          className="headline-2 text-color-primary-dark ta-sm-c"
          style={{ margin: '0' }}
        >
          {this.props.title}
        </p>
        <PopupConfirm
          cancelText={this.props.RL_Cancel}
          closeModal={() => this.closeModal('exportConfirm')}
          confirmText={this.props.RL_Proceed}
          content={this.props.RL_EJExportWarning}
          customConfirmAction={(
            <div className="csv-link">
              <CSVLink
                data={this.getCsvData(this.props.data)}
                filename="ej-transactions.csv"
              >
                <div className="btn-proceed">
                  <ButtonStyled
                    appearance="primary"
                    className="responsive-btn"
                    style={{ color: 'white' }}
                    onClick={this.submitExportWarning}
                  >
                    {this.props.RL_Proceed}
                  </ButtonStyled>
                </div>
              </CSVLink>
            </div>
                    )}
          headerIcon={<AlertCircle size="l" style={{ paddingRight: '0' }} />}
          isOpen={this.state.isOpenExportConfirm}
          submitModel={this.submitExportWarning}
        />

        <PopupConfirm
          cancelText={this.props.RL_Cancel}
          closeModal={() => this.closeModal('exportSuccess')}
          content={this.props.RL_EJExportSuccess}
          headerIcon={<CheckCircle size="l" style={{ paddingRight: '0' }} />}
          isOpen={this.state.isOpenExportSuccess}
          submitModel={() => this.closeModal('exportSuccess')}
        />
        <div style={{ position: 'absolute', right: 0, top: '-10px' }}>
          <ButtonBlack
            className="mt2-sm"
            label={this.props.RL_Export}
            onClick={this.handleExportClick}
          />
        </div>
      </header>
    </>
  );
}

ExportSection.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  RL_Cancel: PropTypes.string.isRequired,
  RL_EJExportSuccess: PropTypes.string.isRequired,
  RL_EJExportWarning: PropTypes.string.isRequired,
  RL_Export: PropTypes.string.isRequired,
  RL_Proceed: PropTypes.string.isRequired,
  storeInfo: PropTypes.shape({
    storeLocale: PropTypes.string.isRequired,
    storeTimezone: PropTypes.string.isRequired,
  }).isRequired,
  title: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => {
  const { localizedBody } = state;
  return {
    RL_Cancel: localizedBody.RL_Cancel,
    RL_Date: localizedBody.RL_Date,
    RL_EJExportSuccess: localizedBody.RL_EJExportSuccess,
    RL_EJExportWarning: localizedBody.RL_EJExportWarning,
    RL_Export: localizedBody.RL_Export,
    RL_Proceed: localizedBody.RL_Proceed,
  };
};
export default connect(mapStateToProps)(ExportSection);
